import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  getMigrateDocumentsActionState,
  ImmomioIconName,
  MigrateDocuments,
} from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { filter, take } from 'rxjs';

@Component({
  standalone: true,
  selector: 'rs-web-document-hint-modal',
  templateUrl: './document-hint-modal.component.html',
  styleUrls: ['./document-hint-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconWebComponent, TranslateModule, ImmomioButtonComponent],
})
export class DocumentHintModalWebComponent {
  #activeModal = inject(NgbActiveModal);
  #store = inject(Store);

  private readonly migrateDocumentsActionState$ = this.#store.select(
    getMigrateDocumentsActionState
  );
  public readonly immomioIconName = ImmomioIconName;

  public migrateDocuments(markAsRead: boolean): void {
    this.#store.dispatch(MigrateDocuments({ markAsRead }));
    this.migrateDocumentsActionState$
      .pipe(
        filter(res => !res.pending),
        take(1)
      )
      .subscribe(() => this.#activeModal.dismiss());
  }
}
